import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  socialBox: {
    width: '100%',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  divider: {
    display: 'flex',
    width: '100%',
    padding: [0, theme.spacing(3)],
    justifyContent: 'space-between',
  },
  line: {
    width: '45%',
    marginTop: 10,
    borderTop: [1, 'solid', theme.palette.colors.border],
  },
}));



// WEBPACK FOOTER //
// ./src/components/SignUp/components/BuyerRegistration/useStyles.js